let uniqueIdentifier = 1
export const getUniqueIdentifier = (): number => {
  uniqueIdentifier++

  return uniqueIdentifier
}
